// extracted by mini-css-extract-plugin
module.exports = {"root":"quote-with-author_root__BIH6n","author":"quote-with-author_author__G7KfM"};